import React, { useMemo, useCallback, useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as paymentActions from '../actions/paymentActions';
import * as registrationActions from '../actions/registrationActions';
import * as policyActions from '../actions/policyActions';
import { paymentSelector, appSelector } from '../selectors';
import OneTimePayment from '../external-components/payments/onetime/OneTimePayment';
import styles from './OneTimePaymentPage.module.scss';
import { push } from 'connected-react-router';
import { Button, Message, Container } from 'semantic-ui-react';

const OneTimePaymentPage = ({ payment, actions, app }) => {
	const paymentActions = useMemo(() => {
		return {
			...actions,
			submitPayment: actions.submitOnetimePayment,
			shouldCalculateConvienceFee: actions.shouldCalculateConvienceFeeOneTime,
			calculateConvienceFee: actions.calculateConvienceFeeOneTime
		};
	}, [actions]);

	const [showAccountPrompt, setShowAccountPrompt] = useState(true);
	const [policyNumber, setPolicyNumber] = useState(null);
	const [policyHolder, setPolicyHolder] = useState(null);

	useEffect(() => {
		actions.getPaymentSettings();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	//override payment settings
	payment.settings.isWalletEnabled = false;

	const onClose = useCallback(() => {
		actions.push('/');
	}, [actions]);

	const onCreateAccountClick = useCallback(() => {
		const baseUrl = '/registration';
		const additions = [];
		if (policyNumber) {
			additions.push(`policyNumber=${policyNumber}`);
		}
		if (policyHolder) {
			additions.push(`policyHolder=${policyHolder}`);
		}

		var url = baseUrl;
		if (additions.length > 0) {
			url += '?' + additions.join('&');
		}

		actions.push(url);
	}, [actions, policyHolder, policyNumber]);

	const onVerification = useCallback(async ({ policyNumber, policyHolder }) => {
			const result = await actions.hasAccount([policyNumber]);
			if (result.response) {
				setShowAccountPrompt(false);
			}

			setPolicyHolder(policyHolder.displayName);
			setPolicyNumber(policyNumber);
		},
		[actions]
	);

	const canMakePayment = (app.systemToggles || { canMakePayments: false }).canMakePayments || false;

	return (
		<div className={styles.container}>
			{showAccountPrompt && (
				<Container>
					<Message
						className={styles.messageContainer}
						positive
						icon='user plus'
						header='Manage Account Online'
						content={
							<div className={styles.message}>
								<div className={styles.text}>Easily pay your bills, schedule payments, access your policy and claims information, or sign up for paperless</div>
								<div className={styles.button}>
									<Button color='blue' onClick={onCreateAccountClick}>
										Create Account
									</Button>
								</div>
							</div>
						}
					/>
				</Container>
			)}
			<OneTimePayment payment={payment} paymentActions={paymentActions} canMakePayment={canMakePayment} onClose={onClose} onVerification={onVerification} />
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		app: appSelector(state),
		payment: paymentSelector(state),
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		...bindActionCreators({ push }, dispatch),
		...bindActionCreators(policyActions, dispatch),
		...bindActionCreators(paymentActions, dispatch),
		...bindActionCreators(registrationActions, dispatch),
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(OneTimePaymentPage);
